import { styled } from '@mui/system'

export const ShopCardCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 350,
  [theme.breakpoints.down('md')]: {
    width: 350,
  },
  '& > div': {
    '& img': {
      width: 200,
      margin: '10px 0 20px 0',
    },
  },
}))
